/**
 * The four library cards, as one specifier for the slice's own surfaces.
 *
 * The gallery components take all four; naming them one at a time from four modules is the only
 * thing this saves, and it keeps the domain face's list one line rather than four.
 */

export { ArtistCard } from './artist-card'
export { BookCard } from './book-card'
export { LabelCard } from './label-card'
export { MovieCard } from './movie-card'
